export default __webpack_public_path__ + "static/media/swap_icon_white.5ac70d56.svg";